
import {Component, Vue} from 'vue-property-decorator'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import UserGroupInfo from '@/model/modules/UserGroupInfo'
import UserGroupService from '@/service/modules/UserGroupService'
import UserGroupEditor from '@/views/module-user-group-manage/user-group-editor.vue'
import UserGroupTokenEditor from '@/views/module-user-group-manage/user-group-token-editor.vue'
import UserGroupFreightPriceEditor from '@/views/module-user-group-manage/user-group-freight-price-editor.vue'
import UserGroupCourierEditor from '@/views/module-user-group-manage/user-group-courier-editor.vue'
import UserGroupFromUserEditor from '@/views/module-user-group-manage/user-group-from-user-editor.vue'

@Component({
  components: {
    UserGroupFromUserEditor,
    UserGroupCourierEditor,
    UserGroupFreightPriceEditor,
    UserGroupTokenEditor,
    UserGroupEditor
  }
})
export default class ModuleUserGroupManage extends Vue {
  listLoadingState: boolean = false
  headerDefine: any = [
    {text: '用户组ID', value: 'id'},
    {text: '用户组关键字', value: 'groupKey'},
    {text: '用户组名称', value: 'groupName'},
    {text: '用户组介绍', value: 'description'},
    {text: '操作', value: 'action', sortable: false, width: 600}
  ]

  queryLikeResult: BasePageableInfo<UserGroupInfo> = new BasePageableInfo<UserGroupInfo>()
  queryType: string = 'groupKey'
  queryWord: string = ''
  pageNum: number = 1
  pageSize: number = 20
  pageSizeOptions = [{text: '20条/页', value: 20}, {text: '50条/页', value: 50}, {
    text: '200条/页',
    value: 200
  }, {text: '1000条/页', value: 1000}, {text: '2000条/页', value: 2000}]

  mounted() {
    this.refreshAllData()
  }

  refreshAllData() {
    this.listLoadingState = true
    UserGroupService.list({}, this.pageNum - 1, this.pageSize)
      .then((result: BasePageableInfo<UserGroupInfo>) => {
        this.queryLikeResult = result
        this.listLoadingState = false
      })
  }

  newItem() {
    this.editItem(new UserGroupInfo())
  }

  editItem(item: UserGroupInfo) {
    const self = this
    // @ts-ignore
    this.$refs.userGroupEditor.showEditor(item, function () {
      self.refreshAllData()
    })
  }

  editToken(item: UserGroupInfo) {
    const self = this
    // @ts-ignore
    this.$refs.userGroupTokenEditor.showEditor(item, function () {
      self.refreshAllData()
    })
  }

  editFreightPrice(item: UserGroupInfo) {
    const self = this
    // @ts-ignore
    this.$refs.userGroupFreightPriceEditor.showEditor(item, function () {
      self.refreshAllData()
    })
  }

  editGroupCourier(item: UserGroupInfo) {
    const self = this
    // @ts-ignore
    this.$refs.userGroupCourierEditor.showEditor(item, function () {
      self.refreshAllData()
    })
  }

  editGroupFromUser(item: UserGroupInfo) {
    const self = this
    // @ts-ignore
    this.$refs.userGroupFromUserEditor.showEditor(item, function () {
      self.refreshAllData()
    })
  }
}
